import { render, staticRenderFns } from "./ListAssitenceView.vue?vue&type=template&id=5ffde681&"
import script from "./ListAssitenceView.vue?vue&type=script&lang=js&"
export * from "./ListAssitenceView.vue?vue&type=script&lang=js&"
import style0 from "./ListAssitenceView.vue?vue&type=style&index=0&id=5ffde681&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports